import { createContext } from 'react'

export const Auth = createContext()
export const UserInfo = createContext()
export const Seller = createContext()
export const Category = createContext()
export const Order = createContext()
